var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f8b51854588a6bf4512252cf09342309ce508dec"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["os-arg-lujan-de-cuyo@os-city"]={id:"f8b51854588a6bf4512252cf09342309ce508dec"};
      